<template>
  <div id="homePage3" class="home-page">
    <div class="header-section">
      <h1 class="main-title">{{ $t("hp3.mainTitle") }}</h1>
      <h2 class="subtitle">{{ $t("hp3.subtitle") }}</h2>
      <p href="#" class="cta-link">{{ $t("hp3.cta") }}</p>
    </div>

    <div class="carousel-section">
      <div class="carousel-container" ref="carouselContainer">
        <div
          class="carousel-track"
          ref="carouselTrack"
          @touchstart="handleTouchStart"
          @touchmove="handleTouchMove"
          @touchend="handleTouchEnd"
          @mousedown="handleMouseDown"
          @mousemove="handleMouseMove"
          @mouseup="handleMouseUp"
          @mouseleave="handleMouseLeave"
        >
          <div
            v-for="(feature, index) in features"
            :key="index"
            class="feature-card"
          >
            <div class="card-icon" :class="feature.iconClass">
              <img
                :src="feature.icon"
                :alt="feature.title"
                class="icon-image"
              />
            </div>
            <h3 class="card-title">{{ $t(feature.title) }}</h3>
            <p class="card-description">{{ $t(feature.description) }}</p>
          </div>
        </div>
      </div>

      <div class="pagination-dots">
        <button
          v-for="index in Math.min(features.length - 2, 5)"
          :key="index - 1"
          class="dot"
          :class="{ active: currentSlide === index - 1 }"
          @click="goToSlide(index - 1)"
        ></button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      currentSlide: 0,
      isDragging: false,
      startX: 0,
      currentX: 0,
      features: [
        {
          title: "hp3.features.instantActivation.title",
          description: "hp3.features.instantActivation.desc",
          icon: require("@/assets/img/homePage/PT-1.png"),
          iconClass: "icon-shield",
        },
        {
          title: "hp3.features.easyIntegration.title",
          description: "hp3.features.easyIntegration.desc",
          icon: require("@/assets/img/homePage/PT-2.png"),
          iconClass: "icon-code",
        },
        {
          title: "hp3.features.multipleMethods.title",
          description: "hp3.features.multipleMethods.desc",
          icon: require("@/assets/img/homePage/PT-3.png"),
          iconClass: "icon-wallet",
        },
        {
          title: "hp3.features.secureTransactions.title",
          description: "hp3.features.secureTransactions.desc",
          icon: require("@/assets/img/homePage/PT-4.png"),
          iconClass: "icon-lock",
        },
        {
          title: "hp3.features.support1.title",
          description: "hp3.features.support1.desc",
          icon: require("@/assets/img/homePage/PT-5.png"),
          iconClass: "icon-support",
        },
        {
          title: "hp3.features.support2.title",
          description: "hp3.features.support2.desc",
          icon: require("@/assets/img/homePage/PT-6.png"),
          iconClass: "icon-support",
        },
        // {
        //   title: "hp3.features.support2.title",
        //   description: "hp3.features.support2.desc",
        //   icon: require("@/assets/img/homePage/b6.png"),
        //   iconClass: "icon-support",
        // },
      ],
    }
  },
  methods: {
    isRTL() {
      return this.$i18n.locale === "ur"
    },
    goToSlide(index) {
      const maxSlide = Math.min(this.features.length - 3, 4)
      this.currentSlide = Math.min(index, maxSlide)
      this.updateCarousel()
    },
    nextSlide() {
      if (this.isRTL()) {
        if (this.currentSlide > 0) {
          this.currentSlide--
        } else {
          this.currentSlide = Math.min(this.features.length - 3, 4)
        }
      } else {
        if (this.currentSlide < Math.min(this.features.length - 3, 4)) {
          this.currentSlide++
        } else {
          this.currentSlide = 0
        }
      }
      this.updateCarousel()
    },
    prevSlide() {
      if (this.isRTL()) {
        if (this.currentSlide < Math.min(this.features.length - 3, 4)) {
          this.currentSlide++
        } else {
          this.currentSlide = 0
        }
      } else {
        if (this.currentSlide > 0) {
          this.currentSlide--
        } else {
          this.currentSlide = Math.min(this.features.length - 3, 4)
        }
      }
      this.updateCarousel()
    },
    updateCarousel() {
      const track = this.$refs.carouselTrack
      if (track) {
        const slideWidth = 100 / 5
        let translateX = -(this.currentSlide * slideWidth)

        if (this.isRTL()) {
          translateX = -translateX
        }

        track.style.transform = `translateX(${translateX}%)`
      }
    },
    handleTouchStart(e) {
      this.isDragging = true
      this.startX = e.touches[0].clientX
      this.currentX = this.startX
    },
    handleTouchMove(e) {
      if (!this.isDragging) return
      e.preventDefault()
      this.currentX = e.touches[0].clientX
    },
    handleTouchEnd() {
      if (!this.isDragging) return
      this.isDragging = false

      const diff = this.startX - this.currentX
      const threshold = 50

      if (Math.abs(diff) > threshold) {
        if (this.isRTL()) {
          if (diff < 0) {
            this.nextSlide()
          } else {
            this.prevSlide()
          }
        } else {
          if (diff > 0) {
            this.nextSlide()
          } else {
            this.prevSlide()
          }
        }
      }
    },
    handleMouseDown(e) {
      this.isDragging = true
      this.startX = e.clientX
      this.currentX = this.startX
    },
    handleMouseMove(e) {
      if (!this.isDragging) return
      this.currentX = e.clientX
    },
    handleMouseUp() {
      if (!this.isDragging) return
      this.isDragging = false

      const diff = this.startX - this.currentX
      const threshold = 50

      if (Math.abs(diff) > threshold) {
        if (this.isRTL()) {
          if (diff < 0) {
            this.nextSlide()
          } else {
            this.prevSlide()
          }
        } else {
          if (diff > 0) {
            this.nextSlide()
          } else {
            this.prevSlide()
          }
        }
      }
    },
    handleMouseLeave() {
      this.isDragging = false
    },
  },
  watch: {
    "$i18n.locale"() {
      this.$nextTick(() => {
        this.updateCarousel()
      })
    },
  },
  mounted() {
    this.updateCarousel()
  },
}
</script>

<style scoped>
.home-page {
  min-height: 58vh;
  background: #f5f5f5;
  padding: 40px 20px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.header-section {
  text-align: center;
  margin-bottom: 60px;
}

.main-title {
  font-size: 40px;
  font-weight: 500;
  font-weight: bold;
  margin-bottom: 20px;
  letter-spacing: -1px;
}

.subtitle {
  font-size: 40px;
  font-weight: 500;
  font-weight: bold;

  margin-bottom: 30px;
}

.cta-link {
  display: inline-block;
  color: #3252cd;
  font-size: 24px;
  font-weight: 500;
  text-decoration: none;
  transition: color 0.3s ease;
}

.cta-link:hover {
  color: #2980b9;
  /* text-decoration: underline; */
}

.carousel-section {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}

.carousel-container {
  position: relative;
  overflow: hidden;
  padding: 20px 0;
}

.carousel-track {
  display: flex;
  transition: transform 0.5s ease-in-out;
  width: 233.33%;
  gap: 20px;
}

[dir="rtl"] .carousel-track {
  flex-direction: row-reverse;
}

.feature-card {
  flex: 0 0 calc(16.666% - 16px);
  padding: 30px 20px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  text-align: left;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: grab;
  min-height: 280px;
  display: flex;
  flex-direction: column;
}

[dir="rtl"] .feature-card {
  text-align: right;
}

.feature-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.feature-card:active {
  cursor: grabbing;
}

.card-icon {
  width: 70px;
  height: 70px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 20px;
  font-size: 1.8rem;
  color: white;
}

[dir="rtl"] .card-icon {
  justify-content: flex-end;
}

.icon-image {
  width: 52px;
  height: 52px;
  object-fit: contain;
  filter: none;
}

.card-title {
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 15px;
  line-height: 1.3;
}

.card-description {
  font-size: 18px;
  color: #7f8c8d;
  line-height: 1.5;
  margin: 0;
  flex-grow: 1;
}

.pagination-dots {
  display: flex;
  justify-content: center;
  margin-top: 30px;
  gap: 16px;
}

.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(17, 103, 240, 0.25);
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease;
  padding: 0;
}

.dot.active {
  background: #06080a;
  transform: none;
}

.dot:not(.active) {
  background: rgba(59, 130, 246, 0.25);
}

.dot:hover {
  background: rgba(59, 130, 246, 0.45);
}

@media (max-width: 768px) {
  .main-title {
    font-size: 2.8rem;
  }

  .subtitle {
    font-size: 1.8rem;
  }

  .carousel-track {
    width: 233.33%;
    gap: 15px;
  }

  [dir="rtl"] .carousel-track {
    flex-direction: row-reverse;
  }

  .feature-card {
    flex: 0 0 calc(14.285% - 12px);
    padding: 20px 15px;
    min-height: 220px;
  }

  [dir="rtl"] .feature-card {
    text-align: right;
  }

  .card-icon {
    width: 60px;
    height: 60px;
    font-size: 1.6rem;
  }

  .icon-image {
    width: 44px;
    height: 44px;
  }

  .card-title {
    font-size: 1.5rem;
  }

  .card-description {
    font-size: 1.1rem;
  }
}

@media (max-width: 480px) {
  .home-page {
    padding: 20px 10px;
  }

  .main-title {
    font-size: 2.2rem;
  }

  .subtitle {
    font-size: 1.5rem;
  }

  .cta-link {
    font-size: 1.1rem;
  }

  .carousel-container {
    padding: 15px 0;
  }

  .carousel-track {
    gap: 12px;
  }

  [dir="rtl"] .carousel-track {
    flex-direction: row-reverse;
  }

  .feature-card {
    flex: 0 0 calc(14.285% - 10px);
    padding: 18px 12px;
    min-height: 200px;
  }

  [dir="rtl"] .feature-card {
    text-align: right;
  }

  .card-icon {
    width: 55px;
    height: 55px;
    font-size: 1.5rem;
  }

  .icon-image {
    width: 38px;
    height: 38px;
  }

  .card-title {
    font-size: 1.6rem;
  }

  .card-description {
    font-size: 1.2rem;
  }
}
</style>
